export const MuiBottomNavigationTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                gap: dt.space.inline.xSmall2,
                height: "auto",
            },
        },
    };
};
